import script from "./MyDailyNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDailyNote.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__